import { LinearProgress } from "@mui/material";

import GeneralErrorAlert from "@/common/components/AppAlerts/GeneralErrorAlert";
import RolesSelector, { RolesSelectorProps } from "@/common/components/Entity/Role/RolesSelector";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";

export interface GlobalRolesSelectorProps extends Omit<
  RolesSelectorProps,
  "getRoles" | "roleList" | "roleAssignmentRestrictions"
> {
  targetUserId?: string | null;
}

export default function AdminGlobalRolesSelector({
  targetUserId,
  ...otherProps
}: GlobalRolesSelectorProps) {
  const roleAssignmentRestrictionsRequest = useApiRequest(
    apiClient.accountAdminApi.apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet,
    {
      targetUserId: targetUserId!,
    },
    {
      deps: [targetUserId],
      skip: !targetUserId,
    },
  );
  const roleAssignmentRestrictions = roleAssignmentRestrictionsRequest?.data;

  if (roleAssignmentRestrictionsRequest.isLoading) {
    return <LinearProgress />;
  }
  if (roleAssignmentRestrictionsRequest.isError) {
    return <GeneralErrorAlert title='Error while loading roles' />;
  }

  return (
    <RolesSelector
      getRoles={async () => {
        const response = await apiClient.accountAdminApi.apiV1AdminAccountGlobalRolesGet();
        return response.data;
      }}
      roleAssignmentRestrictions={roleAssignmentRestrictions}
      {...otherProps}
    />
  );
}
